module.exports = __webpack_public_path__ + "static/dracaena-trifasciata-41ef34955ab34f7c1b36b9b99832e579.svg";